import { render, staticRenderFns } from "./basic_info.vue?vue&type=template&id=8b98a720&scoped=true"
import script from "./basic_info.vue?vue&type=script&lang=js"
export * from "./basic_info.vue?vue&type=script&lang=js"
import style0 from "./basic_info.vue?vue&type=style&index=0&id=8b98a720&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b98a720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b98a720')) {
      api.createRecord('8b98a720', component.options)
    } else {
      api.reload('8b98a720', component.options)
    }
    module.hot.accept("./basic_info.vue?vue&type=template&id=8b98a720&scoped=true", function () {
      api.rerender('8b98a720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/leave_apply_details/components/basic_info.vue"
export default component.exports